import * as svg from "../../../assets/channel-connector-logo.svg";

import {iconBuilder} from "./iconBuilder";

export const ChannelConnectorLogoIcon = iconBuilder(svg, "ChannelConnectorLogoIcon", "0 0 800 800");
